import React from "react";
import SpecialUnit from "./SpecialUnit";

const PoliceHeadQuarter = () => <SpecialUnit speId={9} />;

export default PoliceHeadQuarter;
